import React from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import { AboutYouSubSteps } from './AboutYouSubSteps';

export const YourRoleStep: React.FC<{
  onNext: () => void;
}> = ({ onNext }) => {
  const { goToPreviousStep, canGoBack } = useOnboarding();

  return (
    <AboutYouSubSteps
      subStep="role"
      onNext={onNext}
      onBack={goToPreviousStep}
      canGoBack={canGoBack}
    />
  );
};
